<template>
    <div class="container">
        <FullPageLoading
            :show="showLoading"
            :label="labelLoading"
        />
        <b-modal id="modal-report" title="Report Post">
            <b-form-textarea
                v-model="formReport.description"
                placeholder="Enter something..."
                rows="3"
                max-rows="6"
            />
            <template v-slot:modal-footer>
                <b-button @click="onCancelReport">Cancel</b-button>
                <b-button variant="primary" @click="onSendReport" class="ml-2">Send</b-button>
            </template>
            <template v-slot:modal-header>
                <h3>Report Post</h3>
            </template>
        </b-modal>
        <b-modal id="modal-share" title="Share Post">
            <b-form-textarea
                v-model="formShare.status"
                placeholder="Enter something..."
                rows="3"
                max-rows="6"
            />
            <template v-slot:modal-footer>
                <b-button @click="onCancelShare">Cancel</b-button>
                <b-button variant="primary" @click="onShareConfirm" class="ml-2">Share</b-button>
            </template>
            <template v-slot:modal-header>
                <h3>Share Post</h3>
            </template>
        </b-modal>
        <div class="row">
            <Sidebar />
            <div class="col-12 col-md-9 col-lg-8 newsfeed">
                <div class="d-flex flex-column">
                    <!-- Create a Post -->
                    <div class="card post_status">
                        <div class="card__header bg-whitedarker pb-3">
                            Create a post
                        </div>
                        <div class="card__content">
                            <b-form-textarea placeholder="What's on your mind ?" v-model="form.status"></b-form-textarea>
                        </div>
                        <div class="card__footer d-flex align-items-center justify-content-between">
                            <div class="text-left">
                                <ul class="list-inline post_status__buttons-list">
                                    <li class="list-inline-item" @click="onAddPersonTag"><i class="fa fa-users"></i></li>
                                    <li class="list-inline-item" @click="onAddPhoto"><i class="fa fa-image"></i></li>
                                    <li class="list-inline-item" @click="onAddVideo"><i class="fa fa-video"></i></li>
                                    <li class="list-inline-item" @click="toogleDialogEmoji"><i class="far fa-smile"></i></li>
                                    <div :hidden="dialogHidden" class="emojiPicker">
                                        <VEmojiPicker :pack="emojisNative" labelSearch @select="onSelectEmoji"/>
                                    </div>
                                </ul>
                            </div>
                            <div class="text-right">
                                <button class="btn btn-primary" @click="createPost">Post</button>
                            </div>
                        </div>
                        <vue-tags-input
                            :hidden="addPersonTag"
                            v-model="tags"
                            :tags="form.personTag"
                            :autocomplete-items="autocompleteItems"
                            :add-only-from-autocomplete="true"
                            @tags-changed="updatePersonTag"
                            style="width: 100% !important;max-width: none !important;"
                        />
                        <vue-dropzone :hidden="addPhoto" ref="photos" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
                        <vue-dropzone :hidden="addVideo" ref="videos" id="dropzone" :options="dropzoneOptionsVideo"></vue-dropzone>
                    </div>
                    <!-- End of Create a Post -->
                    <!-- Newsfeed Posts -->
                    <div class="card" v-for="(item, i) in pinnedPost" :key="item.id">
                        <div class="card__header d-flex align-items-center">
                            <img :src="item.user.photo_profile" alt="Avatar">
                            <div class="d-flex flex-column">
                                <div>
                                    <a v-if="item.user.id !== dataUser.id" @click="visitProfile(item.user.id, item.user.full_name)" class="link semi-bold">{{ item.user.full_name }}</a>
                                    <p v-else class="link semi-bold">{{ item.user.full_name }}</p>
                                </div>
                                <div class="d-flex">
                                    <small><i class="fas fa-thumbtack"></i> Pinned</small>&nbsp;
                                    <small><i class="fas fa-clock"></i> {{ item.created_at | fromNow }}</small>
                                    &nbsp;
                                    <small
                                        v-if="item.person_tag !== null"
                                        v-html="personTagPill(item.person_tag)"
                                    ></small>
                                </div>
                            </div>
                        </div>
                        <div class="card__content">
                            <div class="card__content__status" style="white-space: pre-line;">
                                {{ item.status }}
                                <div class="card my-2" v-if="item.shared_post_id !== 0">
                                    <div class="card__header d-flex align-items-center">
                                        <img :src="item.shared_post.user.photo_profile" alt="Avatar">
                                        <div class="d-flex flex-column">
                                            <div>
                                                <a v-if="item.shared_post.user.id !== dataUser.id" @click="visitProfile(item.shared_post.user.id, item.shared_post.user.full_name)" class="link semi-bold">{{ item.shared_post.user.full_name }}</a>
                                                <p v-else class="link semi-bold">{{ item.shared_post.user.full_name }}</p>
                                            </div>
                                            <div class="d-flex">
                                                <small><i class="fas fa-clock"></i> {{ item.shared_post.created_at | fromNow }}</small>
                                                &nbsp;
                                                <small
                                                    v-if="item.person_tag !== null"
                                                    v-html="personTagPill(item.shared_post.person_tag)"
                                                ></small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card__content">
                                        <div class="card__content__status" style="white-space: pre-line;">
                                            {{ item.shared_post.status }}
                                            <div class="card__content__images" v-if="item.shared_post.media.length > 0">
                                                <div class="row">
                                                    <div class="col" v-for="p in item.shared_post.media" :key="p.id" @click="showGalleryItem(item.shared_post.id)">
                                                        <img v-if="p.type === 'photo'" :src="p.url" :alt="item.shared_post.user.full_name + item.shared_post.id">
                                                        <video v-else width="320" height="240" controls>
                                                            <source :src="p.url">
                                                            Your browser does not support playing video.
                                                        </video>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card__content__utils">
                                            <div class="row">
                                                <div class="col-12">
                                                    <ul class="list-inline">
                                                        <li class="list-inline-item" v-if="item.shared_post.likes.length > 0"><i class="fas fa-heart" style="color:red;"></i> {{ item.shared_post.likes.length }} </li>
                                                        <li class="list-inline-item" v-else><i class="far fa-heart"></i> {{ item.shared_post.likes.length }} </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card__content__images" v-if="item.media.length > 0">
                                <div class="row">
                                    <div class="col" v-for="p in item.media" :key="p.id" @click="showGalleryPinned(item.id)">
                                        <img v-if="p.type === 'photo'" :src="p.url" :alt="item.user.full_name + item.id">
                                        <video v-else width="320" height="240" controls>
                                            <source :src="p.url">
                                            Your browser does not support playing video.
                                        </video>
                                    </div>
                                </div>
                            </div>
                            <div class="card__content__utils">
                                <div class="row">
                                    <div class="col-6">
                                        <ul class="list-inline">
                                            <li class="list-inline-item" v-if="isLikedPinned(item.id, i)" @click="onLikePinned(item.id, i)"><i class="far fa-thumbs-up" style="cursor: pointer;color:blue;"></i> {{ item.likes.length }} </li>
                                            <li class="list-inline-item" v-else @click="onLikePinned(item.id, i)"><i class="far fa-thumbs-up" style="cursor: pointer;"></i> {{ item.likes.length }} </li>

                                            <li class="list-inline-item" v-if="isDislikedPinned(item.id, i)" @click="onDislikePinned(item.id, i)"><i class="far fa-thumbs-down" style="cursor: pointer;color:red;"></i> {{ item.dislikes.length }} </li>
                                            <li class="list-inline-item" v-else @click="onDislikePinned(item.id, i)"><i class="far fa-thumbs-down" style="cursor: pointer;"></i> {{ item.dislikes.length }} </li>
                                        </ul>
                                    </div>
                                    <div class="col-6 text-right">
                                        <ul class="list-inline">
                                            <li v-if="item.shared_post_id === 0" class="list-inline-item" v-b-modal="'modal-share'" @click="onShare(item.id, item.user.full_name)"><a class=""><i class="far fa-share-square"></i> Share</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card__footer">
                            <div class="comments__section">
                                <div class="comments d-flex align-items-start" v-for="c in item.comments" :key="c.id">
                                    <img class="comments__avatar" :src="c.user.photo_profile" alt="Avatar Comment">
                                    <div class="d-flex flex-column comments__content">
                                        <div class="d-flex justify-content-between">
                                            <a v-if="c.user.id !== dataUser.id" @click="visitProfile(c.user.id, c.user.full_name)" class="link semi-bold">{{ c.user.full_name }}</a>
                                            <p v-else class="link semi-bold">{{ c.user.full_name }}</p>
                                        </div>
                                        <small class="f-grey"><i class="fas fa-clock"></i> {{ c.created_at | fromNow }}</small>
                                        <p>{{ c.status }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="comments__control">
                                <input type="text" placeholder="Write a comment .." v-model="formCommentPinned[i].status" @keyup.enter="createCommentPinned(item.id, i)">
                                <div class="comments__buttons">
                                    <button @click="toogleDialogEmojiCommentPinned(i)"><i class="far fa-smile"></i></button>
                                    <div :hidden="dialogHiddenCommentPinned(i)" class="emojiPicker emojiPickerComment">
                                        <VEmojiPicker :pack="emojisNative" labelSearch @select="onSelectEmojiCommentPinned" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card__option">
                            <b-dropdown variant="link" class="m-2" no-caret style="text-decoration: none;">
                                <template v-slot:button-content>
                                    <i class="fa fa-ellipsis-v" data-toggle="toggle-option"></i>
                                </template>
                                <b-dropdown-item v-if="dataUser.isAdmin !== 0" @click="pinPost(item.id, false)">Unpin Post</b-dropdown-item>
                                <b-dropdown-item v-b-modal="'modal-report'" @click="onReport(item.id)">Report Post</b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>

                    <div class="card" v-for="(item, i) in item" :key="item.id">
                        <div class="card__header d-flex align-items-center">
                            <img :src="item.user.photo_profile" alt="Avatar">
                            <div class="d-flex flex-column">
                                <div>
                                    <a v-if="item.user.id !== dataUser.id" @click="visitProfile(item.user.id, item.user.full_name)" class="link semi-bold">{{ item.user.full_name }}</a>
                                    <p v-else class="link semi-bold">{{ item.user.full_name }}</p>
                                </div>
                                <div class="d-flex">
                                    <small><i class="fas fa-clock"></i> {{ item.created_at | fromNow }}</small>
                                    &nbsp;
                                    <small
                                        v-if="item.person_tag !== null"
                                        v-html="personTagPill(item.person_tag)"
                                    ></small>
                                </div>
                            </div>
                        </div>
                        <div class="card__content">
                            <div class="card__content__status" style="white-space: pre-line;">
                                {{ item.status }}
                                <div class="card my-2" v-if="item.shared_post_id !== 0">
                                    <div class="card__header d-flex align-items-center">
                                        <img :src="item.shared_post.user.photo_profile" alt="Avatar">
                                        <div class="d-flex flex-column">
                                            <div>
                                                <a v-if="item.shared_post.user.id !== dataUser.id" @click="visitProfile(item.shared_post.user.id, item.shared_post.user.full_name)" class="link semi-bold">{{ item.shared_post.user.full_name }}</a>
                                                <p v-else class="link semi-bold">{{ item.shared_post.user.full_name }}</p>
                                            </div>
                                            <div class="d-flex">
                                                <small><i class="fas fa-clock"></i> {{ item.shared_post.created_at | fromNow }}</small>
                                                &nbsp;
                                                <small
                                                    v-if="item.person_tag !== null"
                                                    v-html="personTagPill(item.shared_post.person_tag)"
                                                ></small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card__content">
                                        <div class="card__content__status" style="white-space: pre-line;">
                                            {{ item.shared_post.status }}
                                            <div class="card__content__images" v-if="item.shared_post.media.length > 0">
                                                <div class="row">
                                                    <div class="col" v-for="p in item.shared_post.media" :key="p.id" @click="showGalleryItem(item.shared_post.id)">
                                                        <img v-if="p.type === 'photo'" :src="p.url" :alt="item.shared_post.user.full_name + item.shared_post.id">
                                                        <video v-else width="320" height="240" controls>
                                                            <source :src="p.url">
                                                            Your browser does not support playing video.
                                                        </video>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card__content__utils">
                                            <div class="row">
                                                <div class="col-12">
                                                    <ul class="list-inline">
                                                        <li class="list-inline-item" v-if="item.shared_post.likes.length > 0"><i class="far fa-thumbs-up" style="color:blue;"></i> {{ item.shared_post.likes.length }} </li>
                                                        <li class="list-inline-item" v-else><i class="far fa-thumbs-up"></i> {{ item.shared_post.likes.length }} </li>

                                                        <li class="list-inline-item" v-if="item.shared_post.dislikes.length > 0"><i class="far fa-thumbs-down" style="color:red;"></i> {{ item.shared_post.dislikes.length }} </li>
                                                        <li class="list-inline-item" v-else><i class="far fa-thumbs-down"></i> {{ item.shared_post.dislikes.length }} </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card__content__images" v-if="item.media.length > 0">
                                <div class="row">
                                    <div class="col" v-for="p in item.media" :key="p.id" @click="showGalleryItem(item.id)">
                                        <img v-if="p.type === 'photo'" :src="p.url" :alt="item.user.full_name + item.id">
                                        <video v-else width="320" height="240" controls>
                                            <source :src="p.url">
                                            Your browser does not support playing video.
                                        </video>
                                    </div>
                                </div>
                            </div>
                            <div class="card__content__utils">
                                <div class="row">
                                    <div class="col-6">
                                        <ul class="list-inline">
                                            <li class="list-inline-item" v-if="isLiked(item.id, i)" @click="onLike(item.id, i)"><i class="far fa-thumbs-up" style="cursor: pointer;color:blue;"></i> {{ item.likes.length }} </li>
                                            <li class="list-inline-item" v-else @click="onLike(item.id, i)"><i class="far fa-thumbs-up" style="cursor: pointer;"></i> {{ item.likes.length }} </li>

                                            <li class="list-inline-item" v-if="isDisliked(item.id, i)" @click="onDislike(item.id, i)"><i class="far fa-thumbs-down" style="cursor: pointer;color:red;"></i> {{ item.dislikes.length }} </li>
                                            <li class="list-inline-item" v-else @click="onDislike(item.id, i)"><i class="far fa-thumbs-down" style="cursor: pointer;"></i> {{ item.dislikes.length }} </li>
                                        </ul>
                                    </div>
                                    <div class="col-6 text-right">
                                        <ul class="list-inline">
                                            <li v-if="item.shared_post_id === 0" class="list-inline-item" v-b-modal="'modal-share'" @click="onShare(item.id, item.user.full_name)"><a class="share-btn"><i class="far fa-share-square"></i> Share</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card__footer">
                            <div class="comments__section">
                                <div class="comments d-flex align-items-start" v-for="c in item.comments" :key="c.id">
                                    <img class="comments__avatar" :src="c.user.photo_profile" alt="Avatar Comment">
                                    <div class="d-flex flex-column comments__content">
                                        <div class="d-flex justify-content-between">
                                            <a v-if="c.user.id !== dataUser.id" @click="visitProfile(c.user.id, c.user.full_name)" class="link semi-bold">{{ c.user.full_name }}</a>
                                            <p v-else class="link semi-bold">{{ c.user.full_name }}</p>
                                        </div>
                                        <small class="f-grey"><i class="fas fa-clock"></i> {{ c.created_at | fromNow }}</small>
                                        <p class="mt-1">{{ c.status }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="comments__control">
                                <input type="text" placeholder="Write a comment .." v-model="formComment[i].status" @keyup.enter="createComment(item.id, i)">
                                <div class="comments__buttons">
                                    <button @click="toogleDialogEmojiComment(i)"><i class="far fa-smile"></i></button>
                                    <div :hidden="dialogHiddenComment(i)" class="emojiPicker emojiPickerComment">
                                        <VEmojiPicker :pack="emojisNative" labelSearch @select="onSelectEmojiComment" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card__option">
                            <b-dropdown variant="link" class="m-2" no-caret style="text-decoration: none;">
                                <template v-slot:button-content>
                                    <i class="fa fa-ellipsis-v" data-toggle="toggle-option"></i>
                                </template>
                                <b-dropdown-item v-if="dataUser.isAdmin !== 0" @click="pinPost(item.id, true)">Pin Post</b-dropdown-item>
                                <b-dropdown-item v-b-modal="'modal-report'" @click="onReport(item.id)">Report Post</b-dropdown-item>
                                <b-dropdown-item v-if="item.user.id === dataUser.id" @click="onDeletePost(item.id)">Delete Post</b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>

                    <vue-gallery-slideshow :images="images" :index="index" @close="index = null"></vue-gallery-slideshow>
                    <infinite-loading @infinite="infiniteHandler" spinner="waveDots" ref="infiniteLoader">
                        <span slot="no-more">
                            <!-- <div class="card">
                                <div class="card__content">
                                    <div class="card__content__status" style="white-space: pre-line;">
                                        <p class="m-0 text-secondary">You just have reach the last post!</p>
                                    </div>
                                </div>
                            </div> -->
                        </span>
                        <span slot="no-results">
                            <div class="card">
                                <div class="card__content">
                                    <div class="card__content__status" style="white-space: pre-line;">
                                        <img src="@/assets/img/post.png" alt="Empty Post" width="200">
                                        <p class="m-0 text-secondary">There is no any posts yet.</p>
                                    </div>
                                </div>
                            </div>
                        </span>
                    </infinite-loading>
                    <!-- End of Newsfeed Posts -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const CryptoJS = require("crypto-js");
const config = require('../config/config.js');
const { aes } = config;
import vue2Dropzone from 'vue2-dropzone';
import moment from 'moment';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import VueTagsInput from '@johmun/vue-tags-input';
import VEmojiPicker from 'v-emoji-picker';
import packData from 'v-emoji-picker/data/emojis.json';
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading';
import FullPageLoading from './FullPageLoading.vue';
import VueGallerySlideshow from 'vue-gallery-slideshow';
import Sidebar from './Sidebar.vue';

export default {
    components: {
        vueDropzone: vue2Dropzone,
        VueTagsInput,
        VEmojiPicker,
        FullPageLoading,
        InfiniteLoading,
        VueGallerySlideshow,
        Sidebar,
    },
    data() {
        return {
            dropzoneOptions: {
                url: 'https://httpbin.org/post',
                thumbnailWidth: 150,
                maxFilesize: 2,
                maxFiles: 10,
                addRemoveLinks: true,
                acceptedFiles: 'image/jpg, image/jpeg, image/png',
                autoProcessQueue: false,
                dictDefaultMessage: "<i class='fas fa-cloud-upload-alt'></i> Upload Photo Here"
            },
            dropzoneOptionsVideo: {
                url: 'https://httpbin.org/post',
                thumbnailWidth: 150,
                maxFiles: 2,
                addRemoveLinks: true,
                acceptedFiles: 'video/avi, video/mp4, video/3gp, video/webm, video/wmv',
                autoProcessQueue: false,
                dictDefaultMessage: "<i class='fas fa-cloud-upload-alt'></i> Upload Video Here"
            },
            dialogHidden: true,
            dialogHiddenCommentID: '',
            dialogHiddenCommentIDPinned: '',
            form: {
                status: '',
                place: '',
                photos: [],
                personTag: [],
            },
            formReport: {
                description: ''
            },
            formShare: {
                status: ''
            },
            formComment: [],
            formCommentPinned: [],
            addPersonTag: true,
            addPhoto: true,
            addVideo: true,
            tags: "",
            autocompleteItems: [],
            debounce: null,
            showLoading: false,
            mostDislikedPostItem: null,
            mostSharedPostItem: null,
            labelLoading: 'Please Wait...',
            item: [],
            images: [],
            index: null,
            page: 0,
            pinnedPost: [],
        }
    },
    computed: {
        isLogin: function () {
            return this.$store.state.isLogin;
        },
        dataUser: function () {
            if (this.isLogin) {
                return this.$store.state.dataUser;
            } else {
                return [];
            }
        },
        emojisNative() {
            return packData;
        },
    },
    watch: {
        'tags': 'initItems',
    },
    filters: {
        fromNow: function(val) {
            return moment(val).fromNow();
        },
        personTag: function(val) {
            let p = JSON.parse(val);
            let user = p.join(', ');
            let html = `<b-badge pill variant="primary">${user}</b-badge> `;
            return html;
        },
    },
    methods: {
        goToMessage() {
            this.$router.push({name: 'message'});
        },
        toogleDialogEmoji() {
            this.dialogHidden = !this.dialogHidden;
        },
        toogleDialogEmojiComment(index) {
            if (this.dialogHiddenCommentID !== '' && this.dialogHiddenCommentID === index) {
                this.dialogHiddenCommentID = '';
            } else if (this.dialogHiddenCommentID !== index) {
                this.dialogHiddenCommentIDPinned = '';
                this.dialogHiddenCommentID = index;
            }
        },
        dialogHiddenComment(index) {
            if (this.dialogHiddenCommentID !== index) {
                return true;
            } 
            if (this.dialogHiddenCommentID === index) {
                return false;
            }
        },
        toogleDialogEmojiCommentPinned(index) {
            if (this.dialogHiddenCommentIDPinned !== '' && this.dialogHiddenCommentIDPinned === index) {
                this.dialogHiddenCommentIDPinned = '';
            } else if (this.dialogHiddenCommentIDPinned !== index) {
                this.dialogHiddenCommentIDPinned = index;
                this.dialogHiddenCommentID = '';
            }
        },
        dialogHiddenCommentPinned(index) {
            if (this.dialogHiddenCommentIDPinned !== index) {
                return true;
            } 
            if (this.dialogHiddenCommentIDPinned === index) {
                return false;
            }
        },
        onSelectEmoji(dataEmoji) {
            this.form.status += dataEmoji.emoji;
        },
        onSelectEmojiComment(dataEmoji) {
            this.formComment[this.dialogHiddenCommentID].status += dataEmoji.emoji;
        },
        onSelectEmojiCommentPinned(dataEmoji) {
            this.formCommentPinned[this.dialogHiddenCommentIDPinned].status += dataEmoji.emoji;
        },
        onAddPersonTag() {
            this.addPersonTag = !this.addPersonTag;
        },
        onAddPhoto() {
            this.addPhoto = !this.addPhoto;
        },
        onAddVideo() {
            this.addVideo = !this.addVideo;
        },
        updatePersonTag(newTags) {
            this.autocompleteItems = [];
            this.form.personTag = newTags;
        },
        initItems() {
            if (this.tags < 2) return;
            let payload = {
                scope: 'search',
                data: {
                    access_token: this.dataUser.access_token,
                    filter: {
                        q: this.tags
                    },
                },
            };

            clearTimeout(this.debounce);
            this.debounce = setTimeout(async() => {
                try {
                    let post = await this.$store.dispatch('post', payload);
                    this.autocompleteItems = post.data.message.map(a => {
                        return { text: a.full_name };
                    });
                } catch (err) {
                    this.$bvToast.toast('Tag Person Failed! Please Refresh the Page!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            }, 600);
        },
        async createPost() {
            this.showLoading = true;
            this.labelLoading = 'Creating Post! Please Wait...';

            let payload = {
                scope: 'create',
                data: {
                    access_token: this.dataUser.access_token,
                    status: this.form.status,
                },
            };

            if (this.addPersonTag !== true && this.form.personTag !== null && this.form.personTag !== '') {
                let tagged = [];
                this.form.personTag.forEach((person) => {
                    tagged.push(person.text);
                });
                payload.data.person_tag = JSON.stringify(tagged);
            }

            if (this.addPhoto !== true && this.$refs.photos.getAcceptedFiles().length > 0) {
                payload.data.photos = this.$refs.photos.getAcceptedFiles();
            }

            if (this.addVideo !== true && this.$refs.videos.getAcceptedFiles().length > 0) {
                payload.data.videos = this.$refs.videos.getAcceptedFiles();
            }

            try {
                let post = await this.$store.dispatch('post', payload);
                if (post.data.status) {
                    this.form = {
                        status: '',
                        place: '',
                        photos: [],
                        personTag: [],
                    };
                    this.addPersonTag = true;
                    this.addPhoto = true;
                    this.addVideo = true;
                    this.showLoading = false;
                    
                    this.page = 0;
                    this.item = [];
                    this.pinnedPost = [];
                    this.formComment = [];
                    this.formCommentPinned = [];
                    this.$refs.infiniteLoader.$emit('$InfiniteLoading:reset');
                    this.$refs.photos.removeAllFiles();
                    this.$refs.videos.removeAllFiles();

                    this.$bvToast.toast('Create Post Success!', {
                        title: 'Success',
                        variant: 'success',
                        autoHideDelay: 2000,
                    });
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Create Post Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Create Post Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async createComment(postId, postIndex) {
            this.showLoading = true;
            this.labelLoading = 'Creating Comment! Please Wait...';

            let payload = {
                scope: 'createComment',
                data: {
                    access_token: this.dataUser.access_token,
                    status: this.formComment[postIndex].status,
                    post_id: postId,
                },
            };

            try {
                let comment = await this.$store.dispatch('post', payload);
                if (comment.data.status) {
                    this.formComment[postIndex].status = '';
                    this.showLoading = false;

                    this.item[postIndex].comments.push(comment.data.data);

                    this.$bvToast.toast('Create Comment Success!', {
                        title: 'Success',
                        variant: 'success',
                        autoHideDelay: 2000,
                    });
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Create Comment Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Create Comment Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async createCommentPinned(postId, postIndex) {
            this.showLoading = true;
            this.labelLoading = 'Creating Comment! Please Wait...';

            let payload = {
                scope: 'createComment',
                data: {
                    access_token: this.dataUser.access_token,
                    status: this.formCommentPinned[postIndex].status,
                    post_id: postId,
                },
            };

            try {
                let comment = await this.$store.dispatch('post', payload);
                if (comment.data.status) {
                    this.formCommentPinned[postIndex].status = '';
                    this.showLoading = false;

                    this.pinnedPost[postIndex].comments.push(comment.data.data);

                    this.$bvToast.toast('Create Comment Success!', {
                        title: 'Success',
                        variant: 'success',
                        autoHideDelay: 2000,
                    });
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Create Comment Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Create Comment Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async infiniteHandler($state) {
            this.page += 1;

            let payload = {
                scope: 'load',
                data: {
                    access_token: this.dataUser.access_token,
                    page: this.page,
                },
            };

            try {
                let post = await this.$store.dispatch('post', payload);
                if (post.data.status) {
                    if (post.data.message.length > 0) {
                        post.data.message.forEach((m) => {
                            if (m.isPinned === 0) {
                                this.item.push(m);
                                this.formComment.push({status: ''});
                            } else {
                                this.pinnedPost.push(m);
                                this.formCommentPinned.push({status: ''});
                            }
                        });
                        $state.loaded();
                    } else {
                        this.page -= 1;
                        $state.complete();
                    }
                } else {
                    this.page -= 1;
                    $state.error();
                    if (post.data.message !== 'Invalid API Request') {
                        this.$bvToast.toast('Load Post Failed! Please Refresh the page!', {
                            title: 'Failed',
                            variant: 'warning',
                            autoHideDelay: 2000,
                        });
                    }
                }
            } catch (err) {
                this.page -= 1;
                $state.error();
                this.$bvToast.toast('Load Post Failed! Please Refresh the page!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        showGalleryItem(id) {
            this.images = [];
            this.index = 0;
            this.item.forEach((i) => {
                if (id === i.id) {
                    i.media.forEach((p) => {
                        if (p.type === 'photo') {
                            this.images.push(p.url);
                        }
                    });
                }
            });
        },
        showGalleryPinned(id) {
            this.images = [];
            this.index = 0;
            this.pinnedPost.forEach((i) => {
                if (id === i.id) {
                    i.media.forEach((p) => {
                        if (p.type === 'photo') {
                            this.images.push(p.url);
                        }
                    });
                }
            });
        },
        personTagPill(name) {
            let p = JSON.parse(name);
            let html = ' - <i class="fa fa-users"></i> ';
            p.forEach((user) => {
                html += `<b-badge pill variant="primary">${user}</b-badge> `;
            });
            return html;
        },
        isLiked(postId, postIndex) {
            if (typeof this.item[postIndex].likes !== 'undefined') {
                let index = this.item[postIndex].likes.findIndex(el => el.user_id === this.dataUser.id);
                if (index !== -1) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        isDisliked(postId, postIndex) {
            if (typeof this.item[postIndex].dislikes !== 'undefined') {
                let index = this.item[postIndex].dislikes.findIndex(el => el.user_id === this.dataUser.id);
                if (index !== -1) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        async onDislike(postId, postIndex) {
            this.showLoading = true;
            this.labelLoading = 'Please Wait...';

            let payload = {
                scope: 'dislikePost',
                data: {
                    access_token: this.dataUser.access_token,
                    type: 'post',
                    pid: postId,
                },
            };

            try {
                let dislike = await this.$store.dispatch('post', payload);
                if (dislike.data.status) {
                    this.showLoading = false;

                    this.item[postIndex].dislikes = dislike.data.data.dislikes;
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Dislike Post Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Dislike Post Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async onLike(postId, postIndex) {
            this.showLoading = true;
            this.labelLoading = 'Please Wait...';

            let payload = {
                scope: 'likePost',
                data: {
                    access_token: this.dataUser.access_token,
                    type: 'post',
                    pid: postId,
                },
            };

            try {
                let like = await this.$store.dispatch('post', payload);
                if (like.data.status) {
                    this.showLoading = false;

                    this.item[postIndex].likes = like.data.data.likes;
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Like Post Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Like Post Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async onDisLike(postId, postIndex) {
            this.showLoading = true;
            this.labelLoading = 'Please Wait...';

            let payload = {
                scope: 'dislikePost',
                data: {
                    access_token: this.dataUser.access_token,
                    type: 'post',
                    pid: postId,
                },
            };

            try {
                let dislike = await this.$store.dispatch('post', payload);
                if (dislike.data.status) {
                    this.showLoading = false;

                    this.item[postIndex].likes.splice(this.item[postIndex].likes.findIndex(el => el.user_id === this.dataUser.id), 1);

                    // this.$bvToast.toast('Dislike Post Success!', {
                    //     title: 'Success',
                    //     variant: 'success',
                    //     autoHideDelay: 2000,
                    // });
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Dislike Post Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Dislike Post Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        isLikedPinned(postId, postIndex) {
            if (typeof this.pinnedPost[postIndex] !== 'undefined') {
                let index = this.pinnedPost[postIndex].likes.findIndex(el => el.user_id === this.dataUser.id);
                if (index !== -1) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        isDislikedPinned(postId, postIndex) {
            if (typeof this.pinnedPost[postIndex] !== 'undefined') {
                let index = this.pinnedPost[postIndex].dislikes.findIndex(el => el.user_id === this.dataUser.id);
                if (index !== -1) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        async onDislikePinned(postId, postIndex) {
            this.showLoading = true;
            this.labelLoading = 'Disliking Post! Please Wait...';

            let payload = {
                scope: 'dislikePost',
                data: {
                    access_token: this.dataUser.access_token,
                    type: 'post',
                    pid: postId,
                },
            };

            try {
                let dislike = await this.$store.dispatch('post', payload);
                if (dislike.data.status) {
                    this.showLoading = false;

                    this.pinnedPost[postIndex].dislikes.splice(this.pinnedPost[postIndex].dislikes.findIndex(el => el.user_id === this.dataUser.id), 1);

                    // this.$bvToast.toast('Dislike Post Success!', {
                    //     title: 'Success',
                    //     variant: 'success',
                    //     autoHideDelay: 2000,
                    // });
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Dislike Post Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Dislike Post Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async onLikePinned(postId, postIndex) {
            this.showLoading = true;
            this.labelLoading = 'Liking Post! Please Wait...';

            let payload = {
                scope: 'likePost',
                data: {
                    access_token: this.dataUser.access_token,
                    type: 'post',
                    pid: postId,
                },
            };

            try {
                let like = await this.$store.dispatch('post', payload);
                if (like.data.status) {
                    this.showLoading = false;

                    this.pinnedPost[postIndex].likes = like.data.data.likes;

                    this.$bvToast.toast('Like Post Success!', {
                        title: 'Success',
                        variant: 'success',
                        autoHideDelay: 2000,
                    });
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Like Post Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Like Post Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async onDisLikePinned(postId, postIndex) {
            this.showLoading = true;
            this.labelLoading = 'Disliking Post! Please Wait...';

            let payload = {
                scope: 'dislikePost',
                data: {
                    access_token: this.dataUser.access_token,
                    type: 'post',
                    pid: postId,
                },
            };

            try {
                let dislike = await this.$store.dispatch('post', payload);
                if (dislike.data.status) {
                    this.showLoading = false;

                    this.pinnedPost[postIndex].likes.splice(this.pinnedPost[postIndex].likes.findIndex(el => el.user_id === this.dataUser.id), 1);

                    this.$bvToast.toast('Dislike Post Success!', {
                        title: 'Success',
                        variant: 'success',
                        autoHideDelay: 2000,
                    });
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Dislike Post Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Dislike Post Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async pinPost(id, status) {
            this.showLoading = true;
            this.labelLoading = (status) ? 'Pinning Post! Please Wait...' : 'Unpinning Post! Please Wait...';

            let payload;
            if (status) {
                payload = {
                    scope: 'pinPost',
                    data: {
                        access_token: this.dataUser.access_token,
                        post_id: id,
                    },
                };
            } else {
                payload = {
                    scope: 'unpinPost',
                    data: {
                        access_token: this.dataUser.access_token,
                        post_id: id,
                    },
                };
            }

            try {
                let post = await this.$store.dispatch('post', payload);
                if (post.data.status) {
                    this.showLoading = false;

                    this.page = 0;
                    this.$refs.infiniteLoader.$emit('$InfiniteLoading:reset');
                    this.item = [];
                    this.pinnedPost = [];
                    this.formComment = [];
                    this.formCommentPinned = [];

                    let statusMessage = (status) ? 'Pinned Post Success!' : 'Unpinned Post Success!';
                    this.$bvToast.toast(statusMessage, {
                        title: 'Success',
                        variant: 'success',
                        autoHideDelay: 2000,
                    });
                } else {
                    this.showLoading = false;
                    let statusMessage = (status) ? 'Pinned Post Failed! Please try again!' : 'Unpinned Post Failed! Please try again!';
                    this.$bvToast.toast(statusMessage, {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                let statusMessage = (status) ? 'Pinned Post Failed! Please try again!' : 'Unpinned Post Failed! Please try again!';
                this.$bvToast.toast(statusMessage, {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        onCancelReport() {
            this.$bvModal.hide('modal-report');
            this.formReport.description = '';
            this.formReport.post_id = '';
        },
        onReport(id) {
            this.formReport.post_id = id;
        },
        async onSendReport() {
            this.showLoading = true;
            this.labelLoading = 'Reporting Post! Please Wait...';

            let payload = {
                scope: 'reportPost',
                data: {
                    access_token: this.dataUser.access_token,
                    post_id: this.formReport.post_id,
                    user_id: this.dataUser.id,
                    description: this.formReport.description
                },
            };

            try {
                let report = await this.$store.dispatch('post', payload);
                if (report.data.status) {
                    this.showLoading = false;

                    this.$bvModal.hide('modal-report');
                    this.formReport.description = '';
                    this.formReport.post_id = '';
                    this.page = 0;
                    this.$refs.infiniteLoader.$emit('$InfiniteLoading:reset');
                    this.item = [];
                    this.pinnedPost = [];
                    this.formComment = [];
                    this.formCommentPinned = [];

                    this.$bvToast.toast('Reporting Post Success!', {
                        title: 'Success',
                        variant: 'success',
                        autoHideDelay: 2000,
                    });
                } else {
                    this.showLoading = false;
                    this.$bvModal.hide('modal-report');
                    this.formReport.description = '';
                    this.formReport.post_id = '';
                    this.$bvToast.toast('Reporting Post Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvModal.hide('modal-report');
                this.formReport.description = '';
                this.formReport.post_id = '';
                this.$bvToast.toast('Reporting Post Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async visitProfile(id, name) {
            this.showLoading = true;
            this.labelLoading = 'Visiting ' + name + ' Profile! Please Wait...';

            let payload = {
                scope: 'visitProfile',
                data: {
                    access_token: this.dataUser.access_token,
                    user_id: id
                },
            };

            try {
                let visit = await this.$store.dispatch('post', payload);
                if (visit.data.status) {
                    this.showLoading = false;

                    localStorage.setItem('visitProfileData', CryptoJS.AES.encrypt(JSON.stringify(visit.data.message), aes));
                    this.$router.push({name: 'visit-profile', params: { id: id, type: 'timeline' }});
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Visiting Profile Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Visiting Profile Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        onShare(id, name) {
            this.formShare.post_id = id;
            this.formShare.name = id;
        },
        onCancelShare() {
            this.$bvModal.hide('modal-share');
            this.formShare.status = '';
            this.formShare.name = '';
            this.formShare.post_id = '';
        },
        async mostDislikedPost() {
            this.showLoading = true;
            this.labelLoading = 'Please Wait...';

            let payload = {
                scope: 'mostDislikedPost',
                data: {
                    access_token: this.dataUser.access_token,
                },
            };

            try {
                let post = await this.$store.dispatch('post', payload);
                this.showLoading = false;
                this.mostDislikedPostItem = post.data.message;
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Load Most Disliked Post Failed! Please Refresh the Page!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async mostSharedPost() {
            this.showLoading = true;
            this.labelLoading = 'Please Wait...';

            let payload = {
                scope: 'mostSharedPost',
                data: {
                    access_token: this.dataUser.access_token,
                },
            };

            try {
                let post = await this.$store.dispatch('post', payload);
                this.showLoading = false;
                this.mostSharedPostItem = post.data.message;
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Load Most Shared Post Failed! Please Refresh the Page!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async onShareConfirm() {
            this.showLoading = true;
            this.labelLoading = 'Sharing ' + name + ' Post! Please Wait...';

            let payload = {
                scope: 'sharePost',
                data: {
                    access_token: this.dataUser.access_token,
                    status: this.formShare.status,
                    shared_post_id: this.formShare.post_id
                },
            };

            try {
                let share = await this.$store.dispatch('post', payload);
                if (share.data.status) {
                    this.showLoading = false;

                    this.$bvModal.hide('modal-share');
                    this.formShare.status = '';
                    this.formShare.post_id = '';
                    this.formShare.name = '';
                    this.page = 0;
                    this.$refs.infiniteLoader.$emit('$InfiniteLoading:reset');
                    this.item = [];
                    this.pinnedPost = [];
                    this.formComment = [];
                    this.formCommentPinned = [];

                    this.$bvToast.toast('Sharing Post Success!', {
                        title: 'Success',
                        variant: 'success',
                        autoHideDelay: 2000,
                    });
                } else {
                    this.showLoading = false;
                    this.$bvToast.toast('Sharing Post Failed! Please try again!', {
                        title: 'Failed',
                        variant: 'warning',
                        autoHideDelay: 2000,
                    });
                }
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Sharing Post Failed! Please try again!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
        async onDeletePost(id) {
            this.showLoading = true;
            this.labelLoading = 'Please Wait...';

            let payload = {
                scope: 'deletePost',
                data: {
                    access_token: this.dataUser.access_token,
                    post_id: id,
                },
            };

            try {
                let post = await this.$store.dispatch('post', payload);
                this.showLoading = false;
                this.page = 0;
                this.$refs.infiniteLoader.$emit('$InfiniteLoading:reset');
                this.item = [];
                this.pinnedPost = [];
                this.formComment = [];
                this.formCommentPinned = [];
                this.$bvToast.toast('Delete Post Success!', {
                    title: 'Success',
                    variant: 'success',
                    autoHideDelay: 2000,
                });
            } catch (err) {
                this.showLoading = false;
                this.$bvToast.toast('Delete Post Failed! Please Refresh the Page!', {
                    title: 'Failed',
                    variant: 'warning',
                    autoHideDelay: 2000,
                });
            }
        },
    }
}
</script>

<style scoped>
    .emojiPicker,
    .emojiPickerComment {
        position: absolute;
        z-index: 99999;
    }
    .emojiPickerComment { left: 220%; }
    .post_status__buttons-list li {
        cursor: pointer;
    }
    .post_status__buttons-list li i {
        padding: .5em;
        border-radius: 50%;
    }
    .post_status__buttons-list li:hover i {
        background-color: rgba(0,0,0,.2);
    }

    .modal-dialog {
        margin-top: 10rem auto !important;
    }
</style>
